'use strict';
import React, { Component, PropTypes } from 'react';
import Select from 'react-select';
import Globalize from 'globalize';

import ErrorBox from './errorBox.js';
import ErrorWrapper from './errorWrapper.js';
import { FormatMessage } from 'react-globalize';


class BfgLoanForm extends Component {

  constructor(props) {
    super(props);

    var imgPath;


    if (this.props.locale == 'es')
      imgPath = 'img/icons/bfgIconLoan.jpg';
    else
      imgPath = "img/icons/bfgIconLoan_en.png";

    this.state = {
      loanFormNameUser: '',
      loanFormLastNameUser: '',
      loanFormAddress: '',
      loanFormStateSelected: '',
      loanFormCitySelected: '',
      loanFormPhone: '',
      loanFormEmailUser: '',
      loanFormSalarySelected: '',
      loanFormZipCode: '',
      bussinesType: [],
      infoMessage: '',
      errorlist: {},
      img: imgPath,
      geocoder: '',
      lat: 0,
      lng: 0,

    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.updateSalary = this.updateSalary.bind(this);
    this.updateState = this.updateState.bind(this);
    this.updateCity = this.updateCity.bind(this);
    this.initializeGeocoder = this.initializeGeocoder.bind(this);
  }

  componentDidMount() {
    this.loadStatesFromServer();
    this.loadSalaryTypeFromServer(this.props.locale);
    if (this.props.loaded) {
      this.initializeGeocoder();
      this.setState({
        initialized: true
      })
    }
  }

  initializeGeocoder() {
    this.geocoder = new google.maps.Geocoder();
  }

  componentWillReceiveProps(nextProps) {

    if (!(this.props.locale == nextProps.locale)) {
      var imgPath;
      if (nextProps.locale == 'es')
        imgPath = 'img/icons/bfgIconLoan.jpg';
      else
        imgPath = "img/icons/bfgIconLoan_en.png";

      this.loadSalaryTypeFromServer(nextProps.locale);

      this.setState({
        img: imgPath
      });

    }
    if (nextProps.loaded && !this.state.initialized) {
      this.initializeGeocoder();
      this.setState({
        initialized: true
      })
    }
  }


  /**
   * @return {object}
   */
  render() {
    var salaryType = this.state.salaryType;
    var states = this.state.data;
    var cities = this.state.cities;
    var disclCss = { "fontSize": "1.3rem", "lineHeight": "1.2", "paddingLeft": "15px", "paddingRight": "15px" };
    return (
      <div className="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2">
        <form className="sendMoney-form" id="loanForm" onSubmit={this.handleSubmit}>
          <header><FormatMessage locale={this.props.locale} path="loansPage/loansPageForm" /></header>
          <fieldset>
            <div className="col-md-8 col-md-offset-2">
              <span className="text-info text-center">{this.props.message}</span>
              <ErrorBox errorlist={this.state.errorlist} locale={this.props.locale} />
            </div>
            <div className="col-md-10 col-md-offset-1">
              <div className="form-group has-feedback">
                <ErrorWrapper errorlist={this.state.errorlist} identifier="loanFormNameUser">
                  <label className="input">
                    <i className="icon-prepend fa fa-user"></i>
                    <input ref="loanFormNameUser" type="text" id="loanFormNameUser"
                      placeholder={Globalize(this.props.locale).messageFormatter('loansPage/loansFormName')()}
                      value={this.state.loanFormNameUser || ''}
                      onChange={this.handleChangeName.bind(this)} className="form-control"
                      min="5" max="40" onBlur={this.handleValidation('loanFormNameUser')} />
                  </label>
                </ErrorWrapper>
              </div>
              <div className="margin-bottom-10"></div>
              <ErrorWrapper errorlist={this.state.errorlist} identifier="loanFormLastNameUser">
                <label className="input">
                  <i className="icon-prepend fa fa-user"></i>
                  <input ref="loanFormLastNameUser" type="text" id="loanFormLastNameUser"
                    placeholder={Globalize(this.props.locale).messageFormatter('loansPage/loansFormLastName')()}
                    value={this.state.loanFormLastNameUser || ''}
                    onChange={this.handleChangeLastName.bind(this)} className="form-control"
                    min="5" max="40" onBlur={this.handleValidation('loanFormLastNameUser')} />
                </label>
              </ErrorWrapper>
              <div className="margin-bottom-10"></div>
              <div className="margin-bottom-10"></div>
              <ErrorWrapper errorlist={this.state.errorlist} identifier="loanFormAddress">
                <label className="input">
                  <i className="icon-prepend fa fa-arrow-right"></i>
                  <input ref="loanFormAddress" id="loanFormAddress"
                    placeholder={Globalize(this.props.locale).messageFormatter('loansPage/loansFormAddress')()}
                    type="text" value={this.state.loanFormAddress || ''}
                    onChange={this.handleChangeAddress.bind(this)} className="form-control"
                    onBlur={this.handleValidation('loanFormAddress')} />
                </label>
              </ErrorWrapper>
              <div className="margin-bottom-10"></div>
              <div className="row">
                <div className="col-md-4 col-sm-4">
                  <ErrorWrapper errorlist={this.state.errorlist} identifier="loanFormStateSelected">
                    <Select className="width-200" ref="loanFormStateSelected"
                      id="loanFormStateSelected" options={states} simpleValue
                      name="loanFormStateSelected"
                      value={this.state.loanFormStateSelected || ''}
                      onChange={this.updateState.bind(this)}
                      placeholder={Globalize(this.props.locale).messageFormatter('agentPage/agentFormState')()}
                      clearable={false} searchable />
                  </ErrorWrapper>
                </div>
                <div className="col-md-4 col-sm-4">
                  <ErrorWrapper errorlist={this.state.errorlist} identifier="loanFormCitySelected">
                    <Select className="width-200" ref="loanFormCitySelected"
                      id="loanFormCitySelected" options={cities} simpleValue
                      name="loanFormCitySelected" disabled={this.state.disabled2}
                      value={this.state.loanFormCitySelected || ''} onChange={this.updateCity}
                      placeholder={Globalize(this.props.locale).messageFormatter('agentPage/agentFormCity')()}
                      clearable={false} searchable />
                  </ErrorWrapper>
                </div>
                <div className="col-md-4 col-sm-4">
                  <ErrorWrapper errorlist={this.state.errorlist} identifier="loanFormZipCode">
                    <label className="input">
                      <i className="icon-prepend fa fa-map-marker"></i>
                      <input ref="loanFormZipCode" id="loanFormZipCode" maxLength={5}
                        type="number"
                        placeholder={Globalize(this.props.locale).messageFormatter('loansPage/loanFormZipCode')()}
                        value={this.state.loanFormZipCode || ''}
                        onChange={this.handleChangeZip.bind(this)} className="form-control"
                        onBlur={this.handleValidationZip('loanFormZipCode')}
                        onKeyPress={this.handleKey} />
                    </label>
                  </ErrorWrapper>
                </div>
              </div>
              <div className="margin-bottom-10"></div>
              <ErrorWrapper errorlist={this.state.errorlist} identifier="loanFormEmailUser">
                <label className="input">
                  <i className="icon-prepend fa fa-envelope-o"></i>
                  <input ref="loanFormEmailUser" id="loanFormEmailUser" type="email"
                    placeholder={Globalize(this.props.locale).messageFormatter('loansPage/loansFormEmail')()}
                    value={this.state.loanFormEmailUser || ''}
                    onChange={this.handleChangeEmail.bind(this)} className="form-control"
                    onBlur={this.handleValidationEmail('loanFormEmailUser')} />
                </label>
              </ErrorWrapper>
              <div className="margin-bottom-10"></div>
              <ErrorWrapper errorlist={this.state.errorlist} identifier="loanFormPhone">
                <label className="input">
                  <i className="icon-prepend fa fa-phone"></i>
                  <input ref="loanFormPhone" id="loanFormPhone"
                    placeholder={Globalize(this.props.locale).messageFormatter('loansPage/loansFormPhone')()}
                    type="tel" value={this.state.loanFormPhone || ''}
                    onChange={this.handleChangePhone.bind(this)} className="form-control"
                    pattern="^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$"
                    onBlur={this.handleValidation('agentFormPhone')} />
                </label>
              </ErrorWrapper>
              <div className="margin-bottom-10"></div>
              <ErrorWrapper errorlist={this.state.errorlist} identifier="loanFormSalarySelected">
                <Select ref="loanFormSalarySelected" id="loanFormSalarySelected" options={salaryType}
                  simpleValue name="loanFormSalarySelected"
                  value={this.state.loanFormSalarySelected || ''}
                  onChange={this.updateSalary.bind(this)}
                  placeholder={Globalize(this.props.locale).messageFormatter('loansPage/loanFormSalarySelected')()}
                  clearable={false} searchable={false} />
              </ErrorWrapper>
              <div className="margin-bottom-10"></div>
              <div className="col-md-8 col-md-offset-2 text-center">
                <div className="margin-bottom-10 "></div>
                <button type="submit" className="btn-u" value="Post"><FormatMessage locale={this.props.locale} path="loansPage/send" /></button>
                {' '}
                <button onClick={this.handleReset} className='btn-u'>Reset</button>
                <div className="margin-bottom-10"></div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12" style={{marginTop: "15px"}}>
                <p className="text-justify" style={disclCss}><FormatMessage locale={this.props.locale} path="loansPage/finalDisclaimer" /></p>
              </div>
            </div>
          </fieldset>
        </form>
      </div>

    );
  }

  handleChangeName(e) {
    e.preventDefault();
    var name = e.target.value;
    this.setState({
      loanFormNameUser: name
    });

  }

  handleChangeLastName(e) {
    e.preventDefault();
    var lastName = e.target.value;
    this.setState({
      loanFormLastNameUser: lastName
    });
  }

  handleChangeEmail(e) {
    e.preventDefault();
    var field = e.target.value;
    this.setState({
      loanFormEmailUser: field
    });
  }

  handleChangePhone(e) {
    e.preventDefault();
    var field = e.target.value;
    this.setState({
      loanFormPhone: field
    });
  }

  handleChangeAddress(e) {
    e.preventDefault();
    var field = e.target.value;
    this.setState({
      loanFormAddress: field
    });
  }

  handleChangeZip(e) {

    e.preventDefault();
    var field = e.target.value;
    if (field.length > 5) {
      e.preventDefault();
      return false;
    } else {
      this.setState({
        loanFormZipCode: field
      });
    }
  }

  handleKey(e) {
    var key = e.keyCode || e.charCode;

    if (!(key > 47 && key < 58)) {
      e.preventDefault();
      return false;
    }
    else {
      return true;
    }
  }

  updateSalary(newValue) {

    if (newValue != '' && this.state.errorlist['loanFormSalarySelected'] != null)
      this.deleteErrors('loanFormSalarySelected');

    this.setState({
      loanFormSalarySelected: newValue
    });
  }

  loadSalaryTypeFromServer(localeId) {
    if (localeId == null)
      this.setState({ bussinesType: [] });
    else
      $.ajax({
        url: '/api/salary_type',
        type: 'POST',
        dataType: 'json',
        data: { locale_id: localeId },
        cache: false,
        success: function (data) {
          this.setState({ salaryType: data });
        }.bind(this),
        error: function (xhr, status, err) {
          console.error(this.props.url, status, err.toString());
        }.bind(this)
      });
  }

  handleValidation(field) {

    return event => {
      event.preventDefault();
      var errors = this.state.errorlist;
      var message = field;

      if (this.validateEmpty(event.target.value)) {
        errors[message] = message + 'Empty';
      } else {
        delete errors[message];
      }

      if (!this.isEmptyObject(errors)) {
        this.setState({
          errorlist: errors
        });
      }
    }
  }

  handleValidationEmail(field) {

    return event => {
      event.preventDefault();
      var errors = this.state.errorlist;
      var message = field;

      if (this.validateEmpty(event.target.value)) {
        errors[message] = message + 'Empty';
      } else if (!this.validateEmail(event.target.value)) {
        alert('handleValidationEmail' + email);
        errors[message] = message + 'Match';
      } else {
        delete errors[message];
      }

      if (!this.isEmptyObject(errors)) {
        this.setState({
          errorlist: errors
        });
      }
    }
  }

  handleValidationZip(field) {

    return event => {
      event.preventDefault();
      var errors = this.state.errorlist;
      var message = field;

      if (this.validateEmpty(event.target.value)) {
        errors[message] = message + 'Empty';
      } else if (!this.validateZipCode(event.target.value)) {
        errors[message] = message + 'Invalid'
      } else {
        delete errors[message];
      }

      if (!this.isEmptyObject(errors)) {
        this.setState({
          errorlist: errors
        });
      }
    }
  }


  getMessageField(field, type) {
    return Globalize(this.props.locale).messageFormatter("errorMessages/" + field + type);
  }

  isEmptyObject(ob) {
    for (var i in ob) {
      return false;
    }
    return true;
  }

  handleReset(event) {
    event.preventDefault();

    this.setState({
      loanFormNameUser: '',
      loanFormLastNameUser: '',
      loanFormAddress: '',
      loanFormStateSelected: '',
      loanFormCitySelected: '',
      loanFormPhone: '',
      loanFormEmailUser: '',
      loanFormSalarySelected: '',
      loanFormZipCode: '',
      infoMessage: '',
      errorlist: {}

    });
  }

  validateEmpty(input) {

    if (!input || input === null || input.length === 0) {
      return true;
    } else {

      return false;
    }

  }

  validateEmail(email) {
    var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return re.test(email);
  }

  validateZipCode(zip) {
    var re = /^[0-9]{5}(?:-[0-9]{4})?$/;
    return re.test(zip);
  }

  loadStatesFromServer() {
    $.ajax({
      url: '/api/usa_states',
      type: 'POST',
      dataType: 'json',
      cache: false,
      success: function (data) {
        this.setState({ data: data });
      }.bind(this),
      error: function (xhr, status, err) {
        console.error(this.props.url, status, err.toString());
      }.bind(this)
    });
  }

  loadCitiesFromServer(idState) {
    if (idState == null)
      this.setState({ cities: [] });
    else
      $.ajax({
        url: '/api/usa_cities',
        type: 'POST',
        dataType: 'json',
        data: { state_iso: idState },
        cache: false,
        success: function (cities) {
          this.setState({ cities: cities });
        }.bind(this),
        error: function (xhr, status, err) {
          console.error(this.props.url, status, err.toString());
        }.bind(this)
      });
  }

  updateState(newValue) {

    if (newValue != '' && this.state.errorlist['loanFormStateSelected'] != null)
      this.deleteErrors('loanFormStateSelected');

    this.setState({
      loanFormStateSelected: newValue
    });

    this.loadCitiesFromServer(newValue);
    this.focusStateSelect();

  }

  updateCity(newValue) {

    if (newValue != '' && this.state.errorlist['loanFormCitySelected'] != null)
      this.deleteErrors('loanFormCitySelected');

    this.setState({
      loanFormCitySelected: newValue
    });
  }

  focusStateSelect() {
    this.refs.loanFormCitySelected.focus();
  }

  deleteErrors(errorName) {
    var errors = this.state.errorlist;
    delete errors[errorName];
    this.setState({
      errorlist: errors
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    var errors = this.state.errorlist;
    var newErrors = {};
    var message = 'Empty';


    if (this.validateEmpty(this.state.loanFormNameUser)) {
      newErrors.loanFormNameUser = 'loanFormNameUser' + message;
    }

    if (this.validateEmpty(this.state.loanFormLastNameUser)) {
      newErrors.loanFormLastNameUser = 'loanFormLastNameUser' + message;
    }

    if (this.validateEmpty(this.state.loanFormAddress)) {
      newErrors.loanFormAddress = 'loanFormAddress' + message;
    }

    if (this.validateEmpty(this.state.loanFormStateSelected)) {

      newErrors.loanFormStateSelected = 'loanFormStateSelected' + message;
    }

    if (this.validateEmpty(this.state.loanFormCitySelected)) {
      newErrors.loanFormCitySelected = 'loanFormCitySelected' + message;
    }

    if (this.validateEmpty(this.state.loanFormZipCode)) {
      newErrors.loanFormZipCode = 'loanFormZipCode' + message;
    } else if (!this.validateZipCode(this.state.loanFormZipCode)) {
      newErrors.loanFormZipCode = 'loanFormZipCodeInvalid';

    }

    if (this.validateEmpty(this.state.loanFormPhone)) {
      newErrors.loanFormPhone = 'loanFormPhone' + message;
    }

    if (this.validateEmpty(this.state.loanFormEmailUser)) {
      newErrors.loanFormEmailUser = 'loanFormEmailUser' + message;
    } else if (!this.validateEmail(this.state.loanFormEmailUser)) {
      newErrors.loanFormEmailUser = 'loanFormEmailUserMatch';
    }

    if (this.validateEmpty(this.state.loanFormSalarySelected)) {

      newErrors.loanFormSalarySelected = 'loanFormSalarySelected' + message;

    }


    if (!this.isEmptyObject(newErrors)) {
      this.setState({
        errorlist: newErrors
      });

    } else {

      var loanFormNameUser = this.state.loanFormNameUser.trim();
      var loanFormLastNameUser = this.state.loanFormLastNameUser.trim();
      var loanFormAddress = this.state.loanFormAddress.trim();
      var loanFormStateSelected = this.state.loanFormStateSelected.trim();
      var loanFormCitySelected = this.state.loanFormCitySelected.trim();
      var loanFormPhone = this.state.loanFormPhone.trim();
      var loanFormEmailUser = this.state.loanFormEmailUser.trim();
      var loanFormSalarySelected = this.state.loanFormSalarySelected.trim();
      var loanFormZipCode = this.state.loanFormZipCode.trim();
      var salaryTypeLabel;
      var stateLabel;
      var cityLabel;


      for (var i = 0; i < this.state.salaryType.length; i++) {
        if (this.state.salaryType[i].value == loanFormSalarySelected) {
          salaryTypeLabel = this.state.salaryType[i].label;
          break;
        }
      }


      for (var i = 0; i < this.state.data.length; i++) {
        let value = this.state.data[i].value.trim();
        if (value == loanFormStateSelected) {
          stateLabel = this.state.data[i].label;
          break;
        }
      }

      for (var i = 0; i < this.state.cities.length; i++) {
        let value = this.state.cities[i].value.trim();
        if (value == loanFormCitySelected) {
          cityLabel = this.state.cities[i].label;
          break;
        }
      }

      var latitud = 0;
      var longitud = 0;


      var address = loanFormAddress + ', ' + cityLabel + ', ' + loanFormStateSelected;

      var country = 'United States';
      var self = this;

      this.geocoder.geocode({ 'address': address, 'country': country }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {

          var location = results[0].geometry.location;

          latitud = location.lat();
          longitud = location.lng();
        }

        self.props.onLoanSubmit({
          loanFormNameUser: loanFormNameUser,
          loanFormLastNameUser: loanFormLastNameUser,
          loanFormEmailUser: loanFormEmailUser,
          loanFormPhone: loanFormPhone,
          loanFormAddress: loanFormAddress,
          loanFormStateSelected: loanFormStateSelected,
          loanFormCitySelected: loanFormCitySelected,
          loanFormZipCode: loanFormZipCode,
          stateLabel: stateLabel,
          cityLabel: cityLabel,
          loanFormSalarySelected: loanFormSalarySelected,
          salaryTypeLabel: salaryTypeLabel,
          lng: longitud,
          lat: latitud
        });

      });


      this.setState({
        loanFormNameUser: '',
        loanFormLastNameUser: '',
        loanFormAddress: '',
        loanFormStateSelected: '',
        loanFormCitySelected: '',
        loanFormZipCode: '',
        loanFormPhone: '',
        loanFormEmailUser: '',
        loanFormSalarySelected: '',
        infoMessage: this.props.message,
        errorlist: {}
      });
    }


  }


}

module.exports = (BfgLoanForm);



// WEBPACK FOOTER //
// ./js/loanForm.js